import styled from "styled-components";
import { Color } from "../theme/Color";

interface NotificationCountProps {
  count: number;
  hasTopMargin?: boolean;
}

const StyledNotificationCount = styled.div<{ hasTopMargin: boolean }>`
  display: flex;
  font-size: 1.2rem;
  margin-top: ${({ hasTopMargin }) => (hasTopMargin ? "0.5rem" : "none")};
  width: 2.4rem;
  height: 2.4rem;
  background: ${Color.Orange5};
  color: ${Color.White};
  border-radius: 50%;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const NotificationCount = ({
  count,
  hasTopMargin = true,
  ...props
}: NotificationCountProps) => {
  return (
    <StyledNotificationCount hasTopMargin={hasTopMargin} {...props}>
      {count}
    </StyledNotificationCount>
  );
};

export default NotificationCount;
